import MobileNav from './header/mobile-nav';
MobileNav();

document.addEventListener('DOMContentLoaded', () => {
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const searchRegion = document.querySelector('.search-form');

  const menuButton = document.querySelector('.hamburger');
  const pageBody = document.getElementsByTagName('body')[0];

  openSearch?.addEventListener('click', () => {
    searchRegion.classList.toggle('open');
    menuButton.classList.remove('is-active');
    pageBody.classList.remove('mobile-nav-open');
  });

  closeSearch?.addEventListener('click', () => {
    searchRegion.classList.remove('open');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const icon = document.querySelector('.js-open-user-menu');
  const menu = document.querySelector('nav.menu--account .menu');

  icon.addEventListener('click', (event) => {
    menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
    event.stopPropagation();
  });

  document.addEventListener('click', () => {
    menu.style.display = 'none';
  });

  menu.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  function adjustContentMargin() {
    const banner = document.querySelector('.course-banner');
    const content = document.querySelector('.node--type-course');
    const messages = document.querySelectorAll('[data-drupal-messages]');

    // Get the height of the banner
    if (!banner) {
      return;
    }
    const bannerHeight = banner.offsetHeight;

    // Set the margin-top of the content dynamically

    if (messages[0]) {
      messages[0].style.marginTop = `${bannerHeight}px`;
      content.style.marginTop = `0px`;
    } else if (content) {
      content.style.marginTop = `${bannerHeight}px`;
    }
  }

  // Adjust margin on page load
  window.onload = adjustContentMargin;

  // Adjust margin on window resize
  window.onresize = adjustContentMargin;
  adjustContentMargin();
});

document.addEventListener('DOMContentLoaded', () => {
  const currentPath = window.location.pathname;
  const links = document.querySelectorAll(
    '.view-member-resource-siblings .views-row a'
  );

  links.forEach((link) => {
    if (link.getAttribute('href') === currentPath) {
      const div = document.createElement('div');
      div.innerHTML = link.innerHTML;
      div.classList.add('current-resource');
      link.parentNode.replaceChild(div, link);
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const loginButton = document.getElementById(
    'edit-login-returning-customer-submit'
  );
  if (loginButton) {
    loginButton.classList.add('step-2-guest-login');
  }

  const guestCheckoutButton = document.getElementById(
    'edit-login-guest-continue'
  );
  if (guestCheckoutButton) {
    guestCheckoutButton.classList.add('step-2-guest-checkout');
  }

  const step3Form = document.querySelector('form[action*="order_information"]');
  const step3Button = step3Form?.querySelector('#edit-actions-next');
  if (step3Button) {
    step3Button.classList.add('step-3-button');
  }

  const step4Form = document.querySelector('form[action*="review"]');
  const step4Button = step4Form?.querySelector('#edit-actions-next');
  if (step4Button) {
    step4Button.classList.add('step-4-button');
  }

  const registrationInputs = document.querySelectorAll(
    '[id^="edit-registration-information-variation-"][id$="registration-registration-anon-mail-0-value--description"]'
  );

  registrationInputs.forEach((input) => {
    // Perform your desired operations on each input element
    input.textContent = 'The email of the person attending the course';
  });

  function checkForEmailFormField() {
    const emailFormItem = document.querySelector(
      '.form-item-payment-information-billing-information-field-email-0-value'
    );

    if (emailFormItem && emailFormItem.querySelector('.description') === null) {
      // Perform your desired operations on the email form item
      const descriptionDiv = document.createElement('div');
      descriptionDiv.className = 'description';
      descriptionDiv.textContent = 'The email for invoices to be sent to';
      emailFormItem.appendChild(descriptionDiv);
    }
  }

  checkForEmailFormField();

  const targetNode = document.querySelector('#edit-payment-information');

  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          checkForEmailFormField();
        }
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  function handleStickyBar() {
    const stickyBar = document.querySelector('.stickybar');
    const footer = document.querySelector('footer');
    const mainContent = document.querySelector('main');

    if (!stickyBar || !footer) {
      return;
    }

    function updateStickyBarPosition() {
      // Hide stickybar on small screens
      if (window.matchMedia('(max-width: 1300px)').matches) {
        stickyBar.style.display = 'none';
        return;
      } else {
        stickyBar.style.display = '';
      }

      const header = document.querySelector('header');
      const adminToolbar = document.querySelector(
        '#toolbar-item-administration-tray'
      );

      const headerHeight = header ? header.offsetHeight : 0;
      const adminToolbarHeight = adminToolbar ? adminToolbar.offsetHeight : 0;
      const topOffset = headerHeight + adminToolbarHeight + 40;

      const stickyBarHeight = stickyBar.offsetHeight;
      const footerRect = footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      const footerTop = footerRect.top + scrollTop;
      const footerVisible = footerRect.top < viewportHeight;
      const maxStickyPosition = footerTop - stickyBarHeight - topOffset - 40;
      const currentScrollPosition = scrollTop;

      if (footerVisible && currentScrollPosition > maxStickyPosition) {
        // Stop sticky behavior and position absolutely before footer
        const absolutePosition = footerTop - stickyBarHeight - topOffset - 40;
        stickyBar.style.position = 'absolute';
        stickyBar.style.top = `${absolutePosition}px`;
        stickyBar.style.bottom = 'auto';
      } else {
        // Resume normal sticky behavior
        stickyBar.style.position = 'fixed';
        stickyBar.style.top = `${topOffset}px`;
        stickyBar.style.bottom = 'auto';
      }
    }

    // Run on scroll and resize
    window.addEventListener('scroll', updateStickyBarPosition);
    window.addEventListener('resize', updateStickyBarPosition);

    // Initial call
    updateStickyBarPosition();
  }

  // Initialize sticky bar handler
  handleStickyBar();
});
